export class FirestoreReference<T> {
    id: string = '';
    path: string = '';
    data: T | null = null;
}
